import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Offline component.
 * Represents a component that renders when the user is offline.
 */
import { useEffect, useState } from 'react';
var Offline = function () {
    var _a = useState(true), isOnline = _a[0], setIsOnline = _a[1];
    var setOnline = function () { return setIsOnline(true); };
    var setOffline = function () { return setIsOnline(false); };
    useEffect(function () {
        window.addEventListener('online', setOnline);
        window.addEventListener('offline', setOffline);
        return function () {
            window.addEventListener('online', setOnline);
            window.addEventListener('offline', setOffline);
        };
    }, []);
    return isOnline ? null : (_jsx("article", { children: _jsxs("section", { children: [_jsx("header", { children: _jsx("h1", { children: "You are offline" }) }), _jsx("main", { children: _jsx("span", { children: "App needs internet to start working" }) })] }) }));
};
export default Offline;
